import VueRouter from "vue-router";

import { usersRoutes } from "./users";
import { authRoutes } from "./auth";
import { frontendsRoutes } from "./frontends";
import { rolesRoutes } from "./roles";
import { dashboardRoutes } from "./dashboard";
import { locationsRoutes } from "./locations";
import { courseTypesRoutes } from "./courseTypes";
import { coursesRoutes } from "./courses";
import { courseCategoriesRoutes } from "./courseCategories";
import { peopleRoutes } from "./people";
import { childrenRoutes } from "./children";
import { peopleCourseWeekRegistrationsRoutes } from "./peopleCourseWeekRegistrations";
import { optionsRoutes } from "./options";
import { blacklistsRoutes } from "./blacklists";

import Index from "./shared/components/template/dashboard/Index";
import PageIndex from "./shared/components/template/pages/Index";
import CourseIndex from "./shared/components/template/pages/CourseIndex";

import { AppPageNotFound, AppUnauthorized } from "./shared/components";
import Vue from "vue";

Vue.use(VueRouter);

const appRoutes = [
  {
    path: "/be",
    component: Index,
    meta: {
      auth: true
    },
    children: [
      ...usersRoutes,
      ...dashboardRoutes,
      ...rolesRoutes,
      ...locationsRoutes,
      ...courseTypesRoutes,
      ...coursesRoutes,
      ...courseCategoriesRoutes,
      ...peopleRoutes,
      ...childrenRoutes,
      ...peopleCourseWeekRegistrationsRoutes,
      ...optionsRoutes,
      ...blacklistsRoutes
    ]
  },
  {
    path: "/",
    component: CourseIndex,
    children: [...frontendsRoutes]
  },
  {
    path: "",
    component: PageIndex,
    children: [...authRoutes]
  },

  {
    path: "/403",
    name: "unauthorized",
    component: AppUnauthorized
  },
  {
    path: "*",
    name: "page-not-found",
    component: AppPageNotFound
  }
];

const routes = [...appRoutes];

export default new VueRouter({
  mode: "history",
  routes
});
